module.exports = __webpack_public_path__ + "media/images/best_place-4dc14d49923a0475e1d9306ad66ca95b.svg";